export default "__VITE_ASSET__CrRep5aH__"